import {ENGAGEMENT_INDEX_ERROR, ENGAGEMENT_INDEX} from "../actions/types";

const INITIAL_STATE = {
    errorMessage: '',
    bottomFormErrorMessage: ''
};

export const engagementIndexReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ENGAGEMENT_INDEX:
            return {
                ...state,
                errorMessage: '',
                bottomFormErrorMessage: ''
            };
        case ENGAGEMENT_INDEX_ERROR:
            return {
                ...state,
                errorMessage: action?.payload
            };

        default:
            return state;
    }
};
